import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiCurrConfig, ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class CurriculumService {
  //private baseUrl = `${environment.apiUrlCurriculum}`;
  private _apiconfig: ApiCurrConfig;
  private apiUrl = '';
  private token = '';

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
   ) { 
    this._apiconfig =  this.configService.apiCurriculumConfig;
    this.apiUrl = this._apiconfig.url;
    this.token = this._apiconfig.token;
   }


  handleError(error: HttpErrorResponse): Observable<never> {
      return throwError(() => new Error(error.message));
  }

  //GetCurriculumFlag   Flag: boolean true/false
  public GetCurriculumFlag(): Observable<any>{
      return this.http.get<any>(`${this.apiUrl}/api/GetCurriculumFlag`, {
        headers: new HttpHeaders()
        .set('Content-Type','application/json'),
        observe: 'response'
      }).pipe(catchError(this.handleError));
  }

  //GetFacultyList
  public GetFacultyList(): Observable<any>{
      return this.http.get<any>(`${this.apiUrl}/api/GetFacultyList`, {
        headers: new HttpHeaders()
        .set('Content-Type','application/json'),
        observe: 'response'
      }
      ).pipe(catchError(this.handleError));
  }

  //GetCurriculumInfo
  public GetCurriculumInfo(facultyId: string): Observable<any>{
      return this.http.get<any>(`${this.apiUrl}/api/GetCurriculumInfo/${facultyId}`, {
        headers: new HttpHeaders()
        .set('Content-Type','application/json'),
        observe: 'response'
      }).pipe(catchError(this.handleError));
  }


  //GetCurriculumCount
  public GetCurriculumCount(): Observable<any>{
    return this.http.get<any>(`${this.apiUrl}/api/GetCurriculumCount`, {
      headers: new HttpHeaders()
      .set('Content-Type','application/json'),
      observe: 'response'
    }).pipe(catchError(this.handleError));
  }
}
